import React from "react";
import styles from "./VideoModal.module.scss";

const VideoModal = ({ closeVideoModal, selectedProduct }) => {
  if (!selectedProduct) return null;
  const { VideoLink } = selectedProduct;
  console.log(VideoLink);

  return (
    <div className={styles.modal}>
      <div className={styles.modalContent}>
        <span className={styles.close} onClick={closeVideoModal}>
          <p>Close</p> <p> Video</p>
        </span>
        <iframe className={styles.iframe} src={VideoLink} frameBorder="0" title="Product Video"></iframe>
      </div>
    </div>
  );
};

export { VideoModal };
